/**
 * Settings Types
 *
 * TypeScript definitions for user settings across all modules.
 * Settings are stored in the backend as JSONB for flexibility.
 */

/**
 * Renovation card view settings
 */
export interface RenovationCardSettings {
  defaultCollapsed: boolean;
  partsExpanded: boolean;
  visibleSections: {
    units: boolean;
    financial: boolean;
    parts: boolean;
    planning: boolean;
  };
  showWarnings: boolean;
}

/**
 * User settings structure
 * Extensible for future modules
 */
export interface UserSettings {
  renovation?: {
    cardView?: RenovationCardSettings;
  };
  // Future modules can add their settings here:
  // helpdesk?: { ... };
  // building?: { ... };
  // dashboard?: { ... };
}

/**
 * User settings entity from backend
 */
export interface UserSettingsEntity {
  id: number;
  userId: string;
  settings: UserSettings;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Default settings for new users
 */
export const DEFAULT_SETTINGS: UserSettings = {
  renovation: {
    cardView: {
      defaultCollapsed: false,
      partsExpanded: false,
      visibleSections: {
        units: true,
        financial: true,
        parts: true,
        planning: true,
      },
      showWarnings: true,
    },
  },
};
